/** Formate un montant lisible (amount_major renvoyé par l'API) dans sa devise. */
export const formatMoney = (amountMajor, currency) => {
    try {
        return new Intl.NumberFormat("fr-CA", { style: "currency", currency }).format(amountMajor);
    } catch {
        return `${amountMajor} ${currency}`;
    }
};

export const PROVIDER_LABELS = {
    square: "Square",
    stripe: "Stripe",
    fedapay: "FedaPay",
};
